import './App.css'
import Header from './components/Header'
import Visual from './components/Visual'
import Feature from './components/Feature'
import Promotion from './components/Promotion'
import About from './components/About/About'
import Brochure from './components/Brochure'
import Footer from './components/Footer'
import Terms from './components/Terms/Terms'
import Privacy from './components/Privacy/Privacy'
import NotFound from './components/NotFound'
import { useRef } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'

function App() {
  const featureRef = useRef()
  const promotionRef = useRef()
  const aboutRef = useRef()
  const downloadRef = useRef()
  
  return (
    <div className="App">  
      <Routes>
        <Route exact path="/" element={ 
          <>
            <Header
              featureRef={featureRef}
              promotionRef={promotionRef}
              aboutRef={aboutRef}
              downloadRef={downloadRef}
            />
            <Visual promotionRef={promotionRef}/>
            <div ref={featureRef}><Feature/></div>
            {/* <div ref={promotionRef}><Promotion></Promotion></div> */}
            <div ref={aboutRef}><About/></div>
            <div ref={downloadRef}><Brochure/></div>
            <Footer/>
          </>
        }/> 
        <Route exact path="/terms" element={ <Terms/> }/>
        <Route exact path="/privacy" element={ <Privacy/> }/>
        <Route exact path="/free-trial" element={ <Promotion/> }/>
        <Route path="*" element={ <NotFound/> }/>
      </Routes>
    </div>
  );
}

export default App;
